import { StaticImage } from "gatsby-plugin-image"

import icon1 from "../../images/svg/1.svg"
import icon2 from "../../images/svg/2.svg"
import icon3 from "../../images/svg/3.svg"
import icon4 from "../../images/svg/4.svg"

const middleEastEventData = {
  color: "#E8E2FF",
  heroTitle: `How Informa leveraged Premagic's AI-powered event gallery to generate additional sponsor revenue`,
  heroImage: (
    <StaticImage
      src="../../images/case-study/middle-east-event/hero.png"
      alt="middle-east-event-show-case-study-hero.png"
    />
  ),
  metrics: {
    quote: `The <b><a href="https://informaconnect.com/middle-east-event-show/">Middle East Event Show (MEES)</a></b> is one of the region’s largest gatherings of event professionals — a space where technology, creativity, and experience design come together.<br/><br/><b><a href="https://informaconnect.com/">Informa Connect</a></b> - global leader in delivering content-driven events, training, and digital experiences organizes around 800 events each year across more than 60 countries They are constantly pushing the envelope on how to deliver value not just to attendees, but also to sponsors who expect tangible ROI from their presence.`,
  },
  images: [
    {
      img: (
        <StaticImage
          src="../../images/case-study/middle-east-event/banner-image.png"
          alt="middle-east-event-show-case-study-banner.png"
          className="md:ml-12"
        />
      ),
    },
    {
      img: (
        <StaticImage
          src="../../images/case-study/middle-east-event/MEES.png"
          alt="middle-east-event-show-case-study.png"
        />
      ),
    },
  ],
  gallery: (
    <StaticImage
      src="../../images/case-study/middle-east-event/gallery.png"
      alt="middle-east-event-show-case-study-gallery.png"
    />
  ),
  caseStudyData: [
    {
      title: "The Challenge",
      subheading: `Informa Connect was looking for a tech solution to drive additional value to their sponsors`,
      info1: `Informa Connect offers multiple sponsorship opportunities with measurable ROI across all its events. Their sponsorship deck already included standard options like lanyard branding, visitor bags, badges, and gift card placements.`,
      info2: `But with Middle East Event Show 2025, Informa Connect wanted to expand their sponsorship opportunities with offerings that had life beyond the event and would be a great addition to their social media engagement, while delivering unprecedented value to their sponsors.`,
    },
    {
      title: "The Solution",
      subheading: `Introducing the Sponsorship Module from Premagic`,
      info1: `<b>Premagic’s <a href="https://premagic.com/sponsored-content/?utm_source=casestudy&utm_medium=casestudy&utm_id=MEES">sponsorship module</a></b> fit Informa Connects requirements neatly - it opened up new sponsorship avenues and category while maintaining the innovation edge, that they are known for.<br/><br/>Premagic’s Sponsorship module would create a new revenue stream for Informa Connect, without compromising on the sponsor and attendee experience.<br/><br/>Informa Connect added a new sponsorship category- <b>“AI Event Gallery Sponsor”</b> -  that would allow the sponsor to make a lasting impact beyond the event. It would get the sponsor a wide brand exposure with their logo watermarked on attendee-shared photos and prominent branding across platform.”`,
      info2: `Informa positioned it in their sponsorship deck as a premium opportunity for exhibitors.<br/><br/>With the AI-Event Gallery and Sponsorship module working in tandem, Premagic and Informa Connect reinvented attendees event experience. The output is no longer just another photo gallery. <br/><br/><b>With Premagic’s AI Event Gallery, each attendee will receive a sponsor branded marketing webpage personalized with each attendee’s photos. Each photo would have the sponsor’s logo.</b><br/><br/><b><a href="https://venuewise.com/">Venue Wise</a></b>, a venue management platform and one of the main sponsors of MEES 2025, recognized the potential of this new sponsorship category and promptly signed up as the AI-Powered Event Gallery sponsor. By giving complete gallery branding to Venue Wise, Informa Connect crafted a clear narrative and built a stronger relationship with their sponsor. The AI event gallery is a highly shareable, branded, and measurable touchpoint that reaches every attendee and extends the sponsor’s reach far beyond event floor.<br/><br/>With over 13,000 registered attendees, the and 7,000+ branded downloads, It is a win-win for both Venue Wise and Informa Connect!`,
      CTA: {
        text: `Learn how Premagic can boost your sponsorship revenue`,
        link: `https://premagic.com/request-a-demo/?utm_source=casestudy&utm_medium=casestudy&utm_id=MEES`,
        position: "center",
      },
    },
    {
      title: "A smarter model for sponsorship activation",
      subheading: `4 powerful sponsor touchpoints within the AI-powered event gallery`,
      info1: `Premagic’s AI-powered event gallery offers multiple, layered branding opportunities for Venue Wise.`,
      image: (
        <StaticImage
          src="../../images/case-study/middle-east-event/smart-model.png"
          alt="middle-east-event-show-case-study-smart-model.png"
        />
      ),
      gridViewPosition: "center",
      gridViewData: [
        {
          icon: (
            <img
              src={icon1}
              alt="Branded marketing page icon"
              width="48"
              height="48"
              loading="lazy"
            />
          ),
          title: "Fully branded marketing page",
          description: `<b>What it did:</b> Showcased Venue Wise branding as the first thing attendees saw in the event gallery<br/><br/><b>Impact:</b> Delivered a premium sponsor impression and strong recall`,
        },
        {
          icon: (
            <img
              src={icon2}
              alt="Sponsor watermark icon"
              width="48"
              height="48"
              loading="lazy"
            />
          ),
          title: "Sponsor watermark on all photos",
          description: `<b>What it did:</b> Embedded subtle branding on every attendee photo in the form of watermarks<br/><br/><b>Impact:</b> Turned every shared photo into an organic brand placement`,
        },
        {
          icon: (
            <img
              src={icon3}
              alt="Logo placement icon"
              width="48"
              height="48"
              loading="lazy"
            />
          ),
          title: "Persistent logo placement in-gallery",
          description: `<b>What it did:</b> Hyperlinked footer logo and banner branding maintained visible logo presence<br/><br/><b>Impact:</b> Increased time spent with brand visuals, boosting familiarity`,
        },
        {
          icon: (
            <img
              src={icon4}
              alt="Sponsor video ad icon"
              width="48"
              height="48"
              loading="lazy"
            />
          ),
          title: "In-gallery sponsor video ad ",
          description: `<b>What it did:</b> Inserted a short, non-intrusive sponsor video between photos<br/><br/><b>Impact:</b> Created a native moment for sponsor’s brand without disrupting flow`,
        },
      ],
      info2: `Outside of the visual branding elements, Premagic also powered organic reach and deep performance insights for the sponsor:<br/><br/><b>Real-time sharing through Attendee Generated Content (AGC):</b> Photos were automatically delivered to attendees, who in turn shared them on social media. This amplified Venue Wise’s presence across attendee networks while generating high-value, peer-driven exposure without additional effort.<br/><br/><b>Sponsor insights dashboard:</b> Venue Wise had access to a live analytics dashboard showing real metrics like views, clicks, shares, and downloads,  allowing them to clearly see the ROI of their sponsorship.`,
      CTA: {
        text: `See how Premagic helps you unlock new sponsorship opportunities`,
        link: `https://premagic.com/request-a-demo/?utm_source=casestudy&utm_medium=casestudy&utm_id=MEES`,
        position: "bottom",
      },
    },
    {
      title: "The Results",
      subheading: `Embracing AI-driven solutions for future events`,
      info1: `The AI-powered event gallery didn't just look good — it delivered real value for both Informa and Venue Wise.`,
      image: (
        <StaticImage
          src="../../images/case-study/middle-east-event/result.png"
          alt="middle-east-event-show-case-study-result.png"
        />
      ),
    },
    {
      subheading: `Massive visual exposure`,
      info2: `
    Imagine every attendee receiving their event photo — and each photo proudly carrying the sponsor’s logo.<br/><br/>
    <b>20,083 high-definition</b> photos were captured and uploaded, each one subtly watermarked with the Venue Wise logo<br/><br/>
    <b>17,141 gallery views</b> ensured repeated brand visibility across thousands of attendees<br/><br/>

    High attendee engagement<br/><br/>
    <ul style="list-style: disc; padding-left: 50px;">
    <li><b>6,903 branded photos</b> were downloaded by the attendees</li>
    <li><b>2,309 unique advocates</b> downloaded and shared these branded photos</li>
    <li><b>48 direct social shares</b> were made from the gallery itself</li>
    </ul> `,
    },
    {
      subheading: `Sponsor content impact`,
      info1: `  The <b>sponsor video ad</b> embedded in the gallery received:<br/><br/>
    <ul style="list-style: disc; padding-left: 50px;">
    <li><b>3,506 impressions</b> on the video ad</li>
    <li><b>1,119 clicks</b> on the sponsor ad video</li>
    <li><b>36 direct calls-to-action</b> from within the gallery</li>
    </ul>`,
    },
    {
      image: (
        <StaticImage
          src="../../images/case-study/middle-east-event/counts.png"
          alt="middle-east-event-show-case-study-count.png"
        />
      ),
      testimonial: {
        img: (
          <StaticImage
            src="../../images/case-study/middle-east-event/avatar.png"
            alt="middle-east-event-show-case-study-avatar.png"
          />
        ),
        message: `“This was the most visible branding we’ve done at any MEES edition. It wasn’t just logo placement—it was interaction, it was measurable, and it kept working even after the event ended.”`,
        name: "Paul Finch",
        info: `Director of Strategic Partnerships,<br />Venue Wise`,
      },
    },
    {
      video: "https://www.youtube.com/embed/g4kgqCDsXas?si=yWyyDsaMYL0N0ADn",
      info2: `<hr/><br/><br/><b>For Informa Connect</b>, this worked as a seamless part of the attendee experience. The AI-event gallery became a destination in itself, driving traffic, social buzz, and goodwill among attendees. Every download, every share, and every branded interaction reflected positively on MEES as a tech-forward event that delivered real ROI to sponsors.`,
    },
    {
      image: (
        <StaticImage
          src="../../images/case-study/middle-east-event/collage.png"
          alt="middle-east-event-show-case-study-collage.png"
        />
      ),
      testimonial: {
        img: (
          <StaticImage
            src="../../images/case-study/middle-east-event/avatar2.png"
            alt="middle-east-event-show-case-study-testimonial-1.png"
          />
        ),
        message: `“What stood out with Premagic was how effortlessly it blended into the MEES experience. It wasn't just about sponsor visibility — it was about creating meaningful touchpoints with attendees, and giving our partners something measurable to walk away with.”`,
        name: "Amar Daginawala",
        info: `Exhibition Director,<br />Informa Middle East`,
      },
      info2: `With detailed engagement analytics, amplified organic reach, and full branding control, Venue Wise walked away with more than just visibility — they walked away with results. And MEES set a new standard for digital-first sponsor activations.`,
      CTA: {
        text: `Transform your event strategy with Premagic`,
        link: `https://premagic.com/request-a-demo/?utm_source=casestudy&utm_medium=casestudy&utm_id=MEES`,
        position: "bottom",
      },
    },
    {
      title: `Rethinking sponsorship value`,
      info1: `At a time when sponsors expect more than just logos on banners, MEES and Informa proved that innovation pays off. By adopting a smarter, digital-first sponsorship model with Premagic, they gave Venue Wise real value and visibility—measurable, memorable, and meaningfully integrated into the attendee experience.`,
      info2: `If you’re looking to offer your sponsors something fresh, data-backed, and instantly impactful, our sponsorship module might just be the edge you need.`,
    },
  ],
  isCTAActive: true,
}

export default middleEastEventData
